import { css, etiColors } from '@eti/styles';
import { vars, breakpoints } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';

type Props = {
  isExpanded: boolean;
};

const wrapperStyles = (isExpanded: boolean) => css`
  p {
    font-size: 0.75rem;

    @media (min-width: ${breakpoints._970}) {
      font-size: 0.875rem;
    }
  }

  ${isExpanded &&
  css`
    border-bottom: none;
    padding-bottom: 9px;
    padding-inline: 20px 28px;
    padding-top: 15px;

    @media (min-width: ${breakpoints._970}) {
      padding-inline: 24px 64px;
    }
  `}
`;

const descriptionStyles = css`
  color: ${etiColors.grayScale[10]};
  font-weight: 400;
  margin-inline-start: 5px;
  padding: 8px 24px;
`;

const headerStyles = (isExpanded: boolean) => css`
  background-color: ${vars.colors.signal.caution.background};
  border-bottom: ${!isExpanded ? `1px dotted ${etiColors.grayScale[7]}` : 'none'};
  color: ${vars.colors.signal.caution.foreground};
  display: flex;
  font-weight: 700;
  padding: 6px 10px;
`;

const TripDetailsDifferentAirport = ({ isExpanded }: Props) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  if (!p('Result.DifferentAirportNotification.Enabled')) {
    return null;
  }

  return (
    <div className={wrapperStyles(isExpanded)} data-testid="trip-details-different-airport">
      <p className={headerStyles(isExpanded)} data-testid="trip-details-different-airport-header">
        {t('Result.TripDetails.DifferentAirport.Header')}
      </p>
      {isExpanded && (
        <p className={descriptionStyles} data-testid="trip-details-different-airport-description">
          {t('Result.TripDetails.DifferentAirport.Description')}
        </p>
      )}
    </div>
  );
};

export default TripDetailsDifferentAirport;
